import { app } from '../../../../../app';
import { Controller } from './customize-saml-assertion.controller';

app.component('customizeSamlAssertion', {
    bindings: {
        application: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./customize-saml-assertion.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/customize-saml-assertion/customize-saml-assertion.component.js